import { render, staticRenderFns } from "./IconFileType.vue?vue&type=template&id=7512f6df"
import script from "./IconFileType.vue?vue&type=script&lang=js"
export * from "./IconFileType.vue?vue&type=script&lang=js"
import style0 from "./IconFileType.vue?vue&type=style&index=0&id=7512f6df&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7512f6df')) {
      api.createRecord('7512f6df', component.options)
    } else {
      api.reload('7512f6df', component.options)
    }
    module.hot.accept("./IconFileType.vue?vue&type=template&id=7512f6df", function () {
      api.rerender('7512f6df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/talent/components/IconFileType.vue"
export default component.exports